module.exports = __webpack_public_path__ + "img/xiaopiao.6a708108.png";